





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderPrivateChatSettingsModal, {
  Followers,
} from '@/components/builder/BuilderPrivateChatSettingsModal.vue'
import { Profile, Subscription } from '@/store/builder/types'
import { ChatStubState } from '@/views/builder/chat/BuilderChat.vue'
import { mapGetters } from 'vuex'
import { Channel } from '@/services/types'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderPrivateChatSettingsModal,
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDot
  },
  computed: {
    ...mapGetters('builder', { profile: 'getProfile', appType: 'getAppType' }),
  },
})
export default class BuilderChatPrivateSettings extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ChatStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  profile!: Profile

  appType!: string

  open = false

  selectedSubscriptions: Record<number, boolean> = {}

  processing = false

  promotionalPageId = 0

  get profileSubscriptions(): Subscription[] {
    return this.profile.subscriptions ?? []
  }

  get subscriptions(): Followers[] {
    return this.profileSubscriptions.map((s) => ({
      id: s.id,
      label: s.name,
      price: s.price,
      selected: !!this.selectedSubscriptions[s.id],
    }))
  }

  set subscriptions(value: Followers[]) {
    this.selectedSubscriptions = value
      .filter((v) => v.selected)
      .reduce((agg, cur) => ({ ...agg, [cur.id]: true }), {})
  }

  @Watch('selectedSubscriptions', { deep: true })
  onSelectedSubscriptionsChange(subs: Record<number, boolean>): void {
    this.$emit('input', {
      channels: this.value.channels.map((c, i) =>
        i === 2
          ? {
              ...c,
              tariffs: this.profileSubscriptions
                .filter((s) => subs[s.id])
                .map((s) => ({
                  id: s.id,
                  type: 0,
                  name: s.name,
                  amount: s.price,
                  period: s.frequency,
                })),
            }
          : c
      ),
    })
  }

  onChannelLock(_: Channel, index: number): void {
    if(this.appType === 'TYPE_STORE') {
      return
    }
    if (index !== 2) {
      return
    }

    this.open = true
  }

  onModalClose(): void {
    this.open = false
  }

  get isNextStepDisabled(): boolean {
    if(this.appType === 'TYPE_STORE') {
      return false
    }
    return !this.promotionalPageId
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }

    this.processing = true

    try {
      await this.$store.dispatch('builder/mutateChannel', {
        id: this.value.channels[2].id,
        promotional_page_id: this.promotionalPageId
        
      })

      this.$emit('next')
    } catch (e: any) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async onStubStateReady(): Promise<void> {
    if (this.value.channels.length < 2) {
      this.$emit('back')
      return
    }

    this.$emit('input', {
      channels: this.value.channels.map((c, i) => (i === 2 ? { ...c, highlight: 'lock' } : c)),
    })

    this.selectedSubscriptions = this.value.channels[2].tariffs.reduce(
      (agg, { id }) => ({ ...agg, [id]: true }),
      {}
    )
  }
}
